import Chart from './Chart/Chart';
import './ChartBlock.css';
import { useEffect, useRef, useState } from 'react';


function ChartBlock(props) {
    const { label, studentValue } = props;
    const arrayLabel = Object.keys(label);

    let parametrKit = "ten";

    switch (arrayLabel.length) {
        case 4:
            parametrKit = "four";
            break;
        case 5:
            parametrKit = "five";
            break;
        case 6:
            parametrKit = "six";
            break;
        case 7:
            parametrKit = "seven";
            break;
        case 8:
            parametrKit = "eight";
            break;
        case 9:
            parametrKit = "nine";
            break;
        case 10:
            parametrKit = "ten";
            break;
        default:
            break;
    }

    const rootElRef = useRef(null);
    const [rootElWidth, setRootElWidth] = useState(1200);
    useEffect(() => {
        const onResize = () => {
            setRootElWidth(rootElRef.current?.offsetWidth);
        }
        onResize()
        window.addEventListener('resize', onResize)

        return () => window.removeEventListener('resize', onResize)
    }, [])

    const chartSize = rootElWidth * 0.52
    const labelFontSize = rootElWidth * 0.024
    const labelLineHeight = rootElWidth * 0.0269

    return (
        <div className="chart-block-container" ref={rootElRef}>
            <div className="chart-block-content">
                {arrayLabel.map((parameter, index) => {
                    const { top, left, width } = studentParametersPosition[parametrKit][index]
                    return (
                        <div
                            key={parameter}
                            className='skill-title'
                            style={{
                                left: `${left}%`,
                                top: `${top}%`,
                                width: `${width}%`,
                                fontSize: `${labelFontSize}px`,
                                lineHeight: `${labelLineHeight}px`,
                            }}
                        >
                            {parameter}
                        </div>
                    )
                })}
            </div>
            <div className="radial-chart" style={{ width: `${chartSize}px`, height: `${chartSize}px` }}>
                <Chart ChartProps={{
                    labels: arrayLabel,
                    data: Object.values(studentValue),
                }} />
            </div>

        </div>

    )
}

export default ChartBlock;


const studentParametersPosition = {
    four: [
        {
            top: 18,
            left: 72,
            width: 30,
        },
        {
            top: 77,
            left: 71,
            width: 20,
        },
        {
            top: 74,
            left: 14,
            width: 15,
        },
        {
            top: 21,
            left: 17,
            width: 22,
        },
    ],
    five: [
        {
            top: 12,
            left: 67,
            width: 30,
        },
        {
            top: 66,
            left: 76,
            width: 20,
        },
        {
            top: 92,
            left: 48,
            width: 15,
        },
        {
            top: 66,
            left: 3,
            width: 22,
        },
        {
            top: 12,
            left: 16,
            width: 20,
        },
    ],
    six: [
        {
            top: 12,
            left: 68,
            width: 30,
        },
        {
            top: 45,
            left: 78,
            width: 20,
        },
        {
            top: 79,
            left: 69,
            width: 15,
        },
        {
            top: 83,
            left: 14,
            width: 22,
        },
        {
            top: 45,
            left: 3,
            width: 20,
        },
        {
            top: 13,
            left: 15,
            width: 23,
        }
    ],
    seven: [
        {
            top: 6,
            left: 60,
            width: 25,
        },
        {
            top: 32,
            left: 76,
            width: 20,
        },
        {
            top: 59,
            left: 77,
            width: 15,
        },
        {
            top: 88,
            left: 60,
            width: 22,
        },
        {
            top: 88,
            left: 22,
            width: 22,
        },
        {
            top: 61,
            left: 9,
            width: 15,
        },
        {
            top: 32,
            left: 3,
            width: 14,
        },
    ],
    eight: [
        {
            top: 6,
            left: 60,
            width: 25,
        },
        {
            top: 32,
            left: 76,
            width: 20,
        },
        {
            top: 59,
            left: 77,
            width: 15,
        },
        {
            top: 88,
            left: 60,
            width: 22,
        },
        {
            top: 88,
            left: 22,
            width: 22,
        },
        {
            top: 61,
            left: 9,
            width: 15,
        },
        {
            top: 32,
            left: 8,
            width: 14,
        },
        {
            top: 5,
            left: 27,
            width: 18,
        },
    ],
    nine: [
        {
            top: 4,
            left: 56,
            width: 25,
        },
        {
            top: 24,
            left: 75,
            width: 20,
        },
        {
            top: 54,
            left: 77,
            width: 15,
        },
        {
            top: 82,
            left: 67,
            width: 22,
        },
        {
            top: 91,
            left: 43,
            width: 22,
        },
        {
            top: 83,
            left: 17,
            width: 15,
        },
        {
            top: 53,
            left: 11,
            width: 14,
        },
        {
            top: 25,
            left: 7,
            width: 18,
        },
        {
            top: 6,
            left: 23,
            width: 18,
        },
    ],
    ten: [
        {
            top: 4,
            left: 54,
            width: 30,
        },
        {
            top: 25,
            left: 74,
            width: 24,
        },
        {
            top: 46,
            left: 78,
            width: 15,
        },
        {
            top: 72,
            left: 74,
            width: 22,
        },
        {
            top: 88,
            left: 55,
            width: 22,
        },
        {
            top: 88,
            left: 25,
            width: 23,
        },
        {
            top: 71,
            left: 9,
            width: 14,
        },
        {
            top: 43,
            left: 3,
            width: 18,
        },
        {
            top: 25,
            left: 13,
            width: 18,
        },
        {
            top: 2,
            left: 30,
            width: 18,
        },
    ],

}

